import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ConsultationPopup from '../../components/feature/ConsultationPopup';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="https://static.readdy.ai/image/fa77cf8cc3bbd77c4d454e1d51d6ad11/4b0a760ad430598ce13c316b2b8752fe.png" alt="A2Z Consulting Services" className="h-12 w-auto" />
            <span className={`text-xl font-semibold ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>A2Z Consulting Services</span>
          </Link>
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`text-sm font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>Home</Link>
            <Link to="/about" className={`text-sm font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>About</Link>
            <Link to="/services" className={`text-sm font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>Services</Link>
            <Link to="/team" className={`text-sm font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>Our Team</Link>
            <Link to="/case-studies" className={`text-sm font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>Success Stories</Link>
            <Link to="/blog" className={`text-sm font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>Resources</Link>
            <Link to="/contact" className={`text-sm font-medium transition-colors hover:opacity-80 ${scrolled ? 'text-[#001F3F]' : 'text-white'}`}>Contact</Link>
          </div>
          <Link to="/contact" className={`hidden md:block px-6 py-2.5 rounded-full text-sm font-medium transition-all hover:scale-105 whitespace-nowrap ${scrolled ? 'bg-[#14B8A6] text-white hover:bg-[#0D9488]' : 'bg-white text-[#001F3F] hover:bg-gray-100'}`}>
            Get Support
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#14B8A6] via-[#0D9488] to-[#0F766E]">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 py-32 z-10 w-full">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-8">
              <i className="ri-heart-line"></i>
              <span>Supporting Your Journey to Success</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-6">
              Guidance for Students,<br />
              Support for Startups,<br />
              <span className="text-white/90">Help for Everyone</span>
            </h1>
            <p className="text-xl text-white/90 leading-relaxed mb-12 max-w-3xl mx-auto">
              Whether you're navigating your academic journey, seeking personal growth, or building your dream startup, we're here to guide you every step of the way.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button onClick={() => setIsPopupOpen(true)} className="px-8 py-4 bg-white text-[#14B8A6] rounded-full font-semibold text-base transition-all hover:scale-105 hover:shadow-2xl flex items-center gap-2 whitespace-nowrap cursor-pointer">
                Book a Free Consultation <i className="ri-arrow-right-line"></i>
              </button>
              <a href="https://wa.me/447494699771" target="_blank" rel="noopener noreferrer" className="px-8 py-4 border-2 border-white text-white rounded-full font-semibold text-base transition-all hover:scale-105 hover:bg-white hover:text-[#14B8A6] whitespace-nowrap flex items-center gap-2">
                <i className="ri-whatsapp-line text-xl"></i> Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <p className="text-xs text-white/80">Discover how we can help</p>
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </div>
      </section>

      {/* Who We Help Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#001F3F] mb-4">Who We Support</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Tailored guidance and support for every stage of your journey
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-graduation-cap-line',
                title: 'Students',
                description: 'Academic guidance, career planning, study strategies, and personal development support to help you excel in your educational journey.',
                color: 'from-[#14B8A6] to-[#0D9488]',
                image: 'https://public.readdy.ai/ai/img_res/08e3aff173754af0db6a61e966d80df3.jpg'
              },
              {
                icon: 'ri-user-heart-line',
                title: 'Individuals',
                description: 'Personal life coaching, goal setting, work-life balance, relationship guidance, and mental wellness support for your personal growth.',
                color: 'from-[#0D9488] to-[#0F766E]',
                image: 'https://readdy.ai/api/search-image?query=Person%20having%20supportive%20one-on-one%20coaching%20session%2C%20warm%20and%20empathetic%20counseling%20environment%2C%20personal%20development%20and%20life%20guidance%2C%20comfortable%20modern%20office%20setting%20with%20natural%20light%2C%20calming%20teal%20accents%20and%20welcoming%20atmosphere&width=400&height=300&seq=personal-help-1&orientation=landscape'
              },
              {
                icon: 'ri-rocket-line',
                title: 'Startups',
                description: 'Business strategy, funding guidance, operational support, and mentorship to help your startup thrive and grow sustainably.',
                color: 'from-[#0F766E] to-[#115E59]',
                image: 'https://readdy.ai/api/search-image?query=Young%20entrepreneurs%20working%20together%20in%20creative%20startup%20office%2C%20diverse%20team%20brainstorming%20business%20ideas%2C%20modern%20collaborative%20workspace%20with%20laptops%20and%20whiteboards%2C%20energetic%20and%20innovative%20atmosphere%2C%20teal%20color%20accents&width=400&height=300&seq=startup-help-1&orientation=landscape'
              }
            ].map((item, index) => (
              <div key={index} className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer hover:-translate-y-2">
                <div className="relative h-48 overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500" />
                  <div className={`absolute inset-0 bg-gradient-to-br ${item.color} opacity-20 group-hover:opacity-30 transition-opacity`}></div>
                </div>
                <div className="p-8">
                  <div className={`w-16 h-16 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                    <i className={`${item.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-[#001F3F] mb-4">{item.title}</h3>
                  <p className="text-base text-gray-600 leading-relaxed mb-6">{item.description}</p>
                  <Link to="/services" className="text-[#14B8A6] font-semibold flex items-center gap-2 hover:gap-3 transition-all">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Approach Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#14B8A6]/10 rounded-full text-[#14B8A6] text-sm font-medium mb-6">
                <i className="ri-heart-pulse-line"></i>
                <span>Our Approach</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-[#001F3F] mb-6 leading-tight">
                Personalized Support<br />
                <span className="text-[#14B8A6]">That Works for You</span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                We believe everyone deserves guidance and support. Our approach is compassionate, practical, and tailored to your unique situation and goals.
              </p>
              <div className="space-y-6">
                {[
                  { icon: 'ri-user-smile-line', title: 'One-on-One Sessions', desc: 'Personal attention focused on your specific needs' },
                  { icon: 'ri-calendar-check-line', title: 'Flexible Scheduling', desc: 'Book sessions that fit your lifestyle' },
                  { icon: 'ri-shield-check-line', title: 'Confidential & Safe', desc: 'Your privacy and trust are our priority' },
                  { icon: 'ri-time-line', title: 'Ongoing Support', desc: "We're here for you throughout your journey" }
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-2xl text-[#14B8A6]`}></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#001F3F] mb-1">{item.title}</h4>
                      <p className="text-sm text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Supportive%20mentor%20having%20warm%20conversation%20with%20young%20person%20in%20comfortable%20modern%20office%2C%20empathetic%20counselor%20listening%20attentively%2C%20caring%20and%20professional%20guidance%20session%2C%20natural%20lighting%2C%20welcoming%20atmosphere%20with%20teal%20accents%2C%20diverse%20and%20inclusive%20setting&width=600&height=700&seq=approach-1&orientation=portrait" 
                  alt="Supportive Guidance" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-[#14B8A6]/20 rounded-full blur-3xl"></div>
              <div className="absolute -top-8 -left-8 w-64 h-64 bg-[#0D9488]/20 rounded-full blur-3xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#001F3F] mb-4">How We Can Help</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Comprehensive support services designed for your success
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-book-open-line', title: 'Academic Support', desc: 'Study strategies, exam preparation, and academic planning' },
              { icon: 'ri-compass-line', title: 'Career Guidance', desc: 'Career planning, CV building, and interview preparation' },
              { icon: 'ri-mental-health-line', title: 'Personal Development', desc: 'Life coaching, goal setting, and confidence building' },
              { icon: 'ri-team-line', title: 'Relationship Support', desc: 'Communication skills and relationship guidance' },
              { icon: 'ri-lightbulb-line', title: 'Startup Mentorship', desc: 'Business planning, strategy, and growth support' },
              { icon: 'ri-funds-line', title: 'Financial Planning', desc: 'Budgeting, funding guidance, and financial literacy' }
            ].map((service, index) => (
              <div key={index} className="group bg-gradient-to-br from-white to-gray-50 rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#14B8A6]/30 cursor-pointer hover:-translate-y-1">
                <div className="w-14 h-14 bg-gradient-to-br from-[#14B8A6] to-[#0D9488] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#001F3F] mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link to="/services" className="inline-flex items-center gap-2 px-8 py-4 bg-[#14B8A6] text-white rounded-full font-semibold text-base transition-all hover:scale-105 hover:bg-[#0D9488] whitespace-nowrap">
              View All Services <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-gradient-to-br from-[#14B8A6]/5 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#001F3F] mb-4">Success Stories</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Real people, real results, real transformations
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: 'Sarah Johnson',
                role: 'University Student',
                text: 'A2Z helped me overcome my exam anxiety and develop effective study strategies. My grades improved dramatically, and I feel so much more confident!',
                image: 'https://readdy.ai/api/search-image?query=Happy%20young%20female%20university%20student%20smiling%20confidently%2C%20diverse%20student%20portrait%2C%20bright%20and%20positive%20expression%2C%20natural%20lighting%2C%20professional%20headshot%20style%2C%20warm%20and%20welcoming%20atmosphere&width=100&height=100&seq=testimonial-1&orientation=squarish'
              },
              {
                name: 'Michael Chen',
                role: 'Startup Founder',
                text: 'The mentorship I received was invaluable. They helped me refine my business model and secure funding. My startup is now thriving!',
                image: 'https://readdy.ai/api/search-image?query=Confident%20young%20male%20entrepreneur%20smiling%2C%20diverse%20startup%20founder%20portrait%2C%20professional%20and%20approachable%20expression%2C%20natural%20lighting%2C%20modern%20business%20headshot%2C%20positive%20atmosphere&width=100&height=100&seq=testimonial-2&orientation=squarish'
              },
              {
                name: 'Emma Williams',
                role: 'Career Changer',
                text: 'I was lost and unsure about my career path. The personal guidance I received helped me discover my passion and land my dream job!',
                image: 'https://readdy.ai/api/search-image?query=Smiling%20professional%20woman%20portrait%2C%20confident%20career%20professional%2C%20diverse%20headshot%2C%20warm%20and%20genuine%20expression%2C%20natural%20lighting%2C%20approachable%20and%20friendly%20atmosphere&width=100&height=100&seq=testimonial-3&orientation=squarish'
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
                <div className="flex items-center gap-1 text-yellow-400 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-lg"></i>
                  ))}
                </div>
                <p className="text-base text-gray-700 leading-relaxed mb-6 italic">"{testimonial.text}"</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-bold text-[#001F3F]">{testimonial.name}</p>
                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-[#14B8A6] to-[#0D9488] relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">Ready to Start Your Journey?</h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto">
            Book a free consultation today and discover how we can support you in achieving your goals.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button onClick={() => setIsPopupOpen(true)} className="inline-flex items-center gap-2 px-10 py-4 bg-white text-[#14B8A6] rounded-full font-bold text-base transition-all hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer">
              Book Free Consultation <i className="ri-calendar-line"></i>
            </button>
            <a href="tel:+447494699771" className="inline-flex items-center gap-2 px-10 py-4 border-2 border-white text-white rounded-full font-bold text-base transition-all hover:scale-105 hover:bg-white hover:text-[#14B8A6] whitespace-nowrap">
              <i className="ri-phone-line"></i> Call Us Now
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] rounded-t-3xl pt-20 pb-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img src="https://static.readdy.ai/image/fa77cf8cc3bbd77c4d454e1d51d6ad11/4b0a760ad430598ce13c316b2b8752fe.png" alt="A2Z" className="h-10 w-auto" />
                <span className="text-xl font-semibold text-white">A2Z Consulting Services</span>
              </div>
              <p className="text-sm text-gray-400 mb-8">Empowering every step of your journey</p>
              <h4 className="text-lg font-bold text-white mb-3">Stay Updated</h4>
              <p className="text-sm text-gray-400 mb-4">Get the latest insights and news</p>
              <div className="flex flex-col gap-3">
                <input type="email" placeholder="Enter your email" className="w-full px-4 py-3 bg-[#2A2A2A] text-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-white/20" />
                <button className="px-7 py-3 bg-white text-black rounded-full text-sm font-medium transition-all hover:scale-105 whitespace-nowrap">
                  Subscribe <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
            <div>
              <h4 className="text-base font-semibold text-white mb-6">Quick Links</h4>
              <div className="flex flex-col gap-4">
                <Link to="/" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Home</Link>
                <Link to="/about" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">About Us</Link>
                <Link to="/services" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Services</Link>
                <Link to="/team" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Our Team</Link>
                <Link to="/case-studies" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Success Stories</Link>
                <Link to="/blog" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Resources</Link>
                <Link to="/pricing" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Pricing</Link>
                <Link to="/faq" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">FAQ</Link>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Contact</Link>
              </div>
            </div>
            <div>
              <h4 className="text-base font-semibold text-white mb-6">Our Services</h4>
              <div className="flex flex-col gap-4">
                <Link to="/services" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Academic Support</Link>
                <Link to="/services" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Career Guidance</Link>
                <Link to="/services" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Personal Development</Link>
                <Link to="/services" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Startup Mentorship</Link>
              </div>
            </div>
            <div>
              <h4 className="text-base font-semibold text-white mb-6">Contact</h4>
              <div className="flex flex-col gap-4 mb-8">
                <a href="tel:+447494699771" className="text-base text-white hover:underline">+44 7494 699 771</a>
                <a href="mailto:hello@a2zconsultingservices.com" className="text-base text-white hover:underline">hello@a2zconsultingservices.com</a>
                <a href="https://wa.me/447494699771" target="_blank" rel="noopener noreferrer" className="text-base text-white hover:underline flex items-center gap-2">
                  <i className="ri-whatsapp-line"></i> WhatsApp Us
                </a>
              </div>
              <h5 className="text-sm text-gray-400 mb-4">Follow Us</h5>
              <p className="text-sm text-gray-400 leading-relaxed">123 Business Avenue<br />Manchester, M1 1AA, UK</p>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">LinkedIn</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Twitter</a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Facebook</a>
            </div>
            <p className="text-sm text-gray-400 text-center">© 2025 A2Z Consulting Services. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-service" className="text-sm text-gray-400 hover:text-white hover:underline transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>

      <ConsultationPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
}
